import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-authenticated-standalone-layout',
  standalone: true,
  imports: [RouterOutlet],
  template: `<main class="standalone-content">
    <router-outlet />
  </main>`,
  styleUrl: './authenticated-standalone-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthenticatedStandaloneLayout {}
